import React, { useEffect, useState } from "react";
import { useGetUserContentListMutation } from "../../../../store/user/contentsApiSlice";
import { getCookie } from "../../../../util/cookie/cookies";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
interface ParamData {contentsType : any, lang : string, page : any, size : number, keyword : string, sortOrder : string, sortColumn : string}
export const PormotionNews = () => {
    const {t} = useTranslation()
    const location = useLocation()
    const type : any = new URLSearchParams(location.search).get('type') || 'ALL'
    const navigate = useNavigate()
    const lang = getCookie('HYUNDAILANG')
    const [param , setParam] = useState<ParamData>({contentsType : 1, lang : lang === 'kr' ? 'KR' : 'EN', page : 1, size : 99, keyword : '', sortOrder : 'desc', sortColumn : 'date'})
    const [getUserContentListApi] = useGetUserContentListMutation()
    const [data, setData] = useState<any>([])
    const getList = async() => {
        const result : any = await getUserContentListApi(param)
        if(result.data.result === true){
            if(type === 'ALL'){setData(result.data.list)}
            else if(type === 'HN'){
                const fomatData = result.data.list.filter((item:any)=>item.prom_tech_type === '현대엔테크 소식')
                if(fomatData){setData(fomatData)}
            } else{
                const fomatData = result.data.list.filter((item:any)=>item.prom_tech_type === '고객경험')
                if(fomatData){setData(fomatData)}
            }
        }
    }
    useEffect(()=>{
        if(lang === 'kr'){setParam((prev)=>({...prev, lang : 'KR'}))}
        else {setParam((prev)=>({...prev, lang : 'EN'}))}
    }, [lang])
    useEffect(()=>{getList()}, [type, param.lang])
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    <h3>
                        <span>{t("prcenter_news_1")}</span>
                        {t("prcenter_news_2")}
                    </h3>
                    
                    <ul className="tabBtnBox">
                        <li className={type === 'ALL' ? 'active' : ''} onClick={()=>navigate(`${location.pathname}?type=ALL`)}>All</li>
                        <li className={type === 'HN' ? 'active' : ''} onClick={()=>navigate(`${location.pathname}?type=HN`)}>{t("prcenter_news_3")}</li>
                        <li className={type === 'CS' ? 'active' : ''} onClick={()=>navigate(`${location.pathname}?type=CS`)}>{t("prcenter_news_4")}</li>
                    </ul>
                </div>
                <div className="right">
                    <ul>
                        {data?.map((list:any) => (
                        <li onClick={()=>navigate(`/prCenter/news/${list?.prom_idx}`)}>
                            <div className="thumbBox">
                                <img src={lang === 'kr'?list?.prom_thumnail_pdsFile_kr:list?.prom_thumnail_pdsFile_en} alt="보도자료 리스트 썸네일"/>
                            </div>
                            <div className="txtBox">
                                <span>{list?.prom_tech_type}</span>
                                <span>{lang === 'kr'?list?.prom_subject_kr : list?.prom_subject_en}</span>
                            </div>
                        </li>

                        ))}
                    </ul>
                </div>
            </div>
        </div>
        </>
    )
}